import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { UserResponse } from '../types';
import { showNotification } from '@/utils/notificationUtils';

export type OTPCredentialsDTO = {
    email: string;
    isSignup?: string;
    otp?: string;
};

export const OTPLogin = (data: OTPCredentialsDTO): Promise<UserResponse> => {
    return axios.post('/business/login/generate-otp', data);
};

type UseUpdateBusinessOptions = {
    config?: MutationConfig<typeof OTPLogin>;
};

export const useOTPLogin = ({ config }: UseUpdateBusinessOptions = {}) => {
    return useMutation({
        ...config,
        onSuccess: () => {
            // showNotification({
            //     type: 'success',
            //     title: 'Otp sent successfully on your email',
            // });
        },
        mutationFn: OTPLogin,
    });
};


export type OTPCredentialsDTO1 = {
    email: string;
    otp?: string;
};

export const OTPVerify = (data: OTPCredentialsDTO1): Promise<UserResponse> => {
    return axios.post('/business/verify/otp', data);
};

type UseUpdateBusinessOptions2 = {
    config?: MutationConfig<typeof OTPLogin>;
};

export const useOtpVerify = ({ config }: UseUpdateBusinessOptions2 = {}) => {
    return useMutation({
        ...config,
        onSuccess: () => {
            // showNotification({
            //     type: 'success',
            //     title: 'Otp sent successfully on your email',
            // });
        },
        mutationFn: OTPVerify,
    });
};
